/* eslint-disable @reatom/unit-naming-rule */
import { action } from '@reatom/framework'

import type { PremiumMetaModel } from './reatom-premium-meta'
import type {
  CurrencyModel,
  CurrencyAddress,
  CurrencyWithPremium,
} from '@root/entities/currency/model'
import type { ServicesApi } from '@root/shared/api'

export const premiumMetaUpdateReceived = action<{
  currency: ServicesApi.TokenMetaDto
  premiumMeta: ServicesApi.PremiumMetaDto
}>('premiumMetaUpdateReceived')

export const openPremiumCurrencyDetailsEvent = action<{
  currencyAddress: CurrencyAddress
}>('openPremiumCurrencyDetailsEvent')

export const openBuyPremiumFlowEvent = action<{
  currency: CurrencyModel
  premium: PremiumMetaModel | undefined
  shouldCheckSafety?: boolean
}>('openBuyPremiumFlowEvent')

export const openBuyBoostersFlowEvent = action<{
  currency: CurrencyModel
  premium: PremiumMetaModel
  shouldCheckSafety?: boolean
}>('openBuyBoostersFlowEvent')

export const openExtendPremiumFlowEvent =
  action<CurrencyWithPremium.CurrencyWithPremium>('openExtendPremiumFlowEvent')
